import * as ambassadorWixFunctionsV1FunctionFormSchema from './functions-v1-function-form-schema-function-form-schemas.http.js';
import * as ambassadorWixFunctionsV1FunctionFormSchemaTypes from './functions-v1-function-form-schema-function-form-schemas.types.js';
import * as ambassadorWixFunctionsV1FunctionFormSchemaUniversalTypes from './functions-v1-function-form-schema-function-form-schemas.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getFunctionFormSchema(): __PublicMethodMetaInfo<
  'GET',
  { functionId: string },
  ambassadorWixFunctionsV1FunctionFormSchemaUniversalTypes.GetFunctionFormSchemaRequest,
  ambassadorWixFunctionsV1FunctionFormSchemaTypes.GetFunctionFormSchemaRequest,
  ambassadorWixFunctionsV1FunctionFormSchemaUniversalTypes.GetFunctionFormSchemaResponse,
  ambassadorWixFunctionsV1FunctionFormSchemaTypes.GetFunctionFormSchemaResponse
> {
  const payload = { functionId: ':functionId' } as any;

  const getRequestOptions =
    ambassadorWixFunctionsV1FunctionFormSchema.getFunctionFormSchema(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/function-form-schemas/{functionId}',
    pathParams: { functionId: 'functionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  FunctionFormSchema as FunctionFormSchemaOriginal,
  FormFieldSourceType as FormFieldSourceTypeOriginal,
  FormFieldSourceTypeWithLiterals as FormFieldSourceTypeWithLiteralsOriginal,
  FormFieldSource as FormFieldSourceOriginal,
  GetFunctionFormSchemaRequest as GetFunctionFormSchemaRequestOriginal,
  GetFunctionFormSchemaResponse as GetFunctionFormSchemaResponseOriginal,
} from './functions-v1-function-form-schema-function-form-schemas.types.js';
